import React from 'react';
import { MainMenu } from './MainMenu';
import { useBranding } from '@/hooks/useBranding';

export const LeftPanel: React.FC = () => {
  const branding = useBranding();

  return (
    <div className="z-20 flex size-full shrink-0 flex-col border-r-2 border-background-300 bg-background-50">
      <div className="h-[100px] w-full overflow-hidden">{branding?.logo}</div>
      <MainMenu />
    </div>
  );
};
